export default __webpack_public_path__ + "static/media/femal_hand_with_phone.13ef35cf.png";